import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-105" data-mp="1lc1zjayu8zq4">
      <div className="mx-auto max-w-2xl" data-id="element-106" data-mp="1gdqqh2gdat8y">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-107" data-mp="1gal25pfkbvea">
          Domande frequenti
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-108" data-mp="292o7714xkhzl">
          {faqs.map((faq, index) => {
          const open = openIndex === index;
          return <li key={faq.q} className="overflow-hidden rounded-2xl border border-brand-100 bg-cream" data-id="element-109" data-mp="1z3732o5buc5q" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} className="flex w-full items-start justify-between gap-3 px-4 py-4 text-left sm:px-5" data-id="element-110" data-mp="smv2yhiy2k7i">
                  <span className="text-[15px] font-bold leading-snug text-ink sm:text-base" data-id="element-111" data-mp="pg3c3tidbnk0">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`mt-[2px] h-5 w-5 shrink-0 text-brand-500 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-112" data-mp="fiqfs9jsb0vp" />
                </button>
                {open ? <p className="px-4 pb-4 text-[14px] font-medium leading-relaxed text-inksoft sm:px-5 sm:text-[15px]" data-id="element-113" data-mp="bk9iehq614rh">
                    {faq.a}
                  </p> : null}
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-114" data-mp="3jxq7lssumtit">
          <CtaButton label="Risolvo i miei dubbi e inizio oggi" note="Accesso immediato · Garanzia di 7 giorni" data-id="element-115" data-mp="3jyhzotn8m94c" />
        </div>
      </div>
    </section>;
}